"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

export function FooterPhoneGate({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (pathname !== "/cart") return children;
  return <div className="max-md:hidden">{children}</div>;
}
